<script setup lang="ts">
import type { SideListProps } from '@/types/appTypes'

const props = withDefaults(defineProps<SideListProps>(), {
  loading: false,
  maxItems: 5,
})
</script>

<template>
  <div class="c-sideList">
    <div
      v-for="(item, index) in items"
      v-bind:key="index"
      class="c-sideList_slotwrap"
    >
      <slot
        v-bind:item="item"
        v-bind:rank="index"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive";

.c-sideList {
  position: relative;

  &_slotwrap {
    // &:nth-child(n + 6) {
    //   display: none;
    // }
  }

  &.sideReport {
    display: grid;
    grid-gap: 1px;
    grid-template-columns: 1fr 1fr 1fr;
    min-height: 495.68px;

    .c-sideList_slotwrap {
      // &:nth-child(n + 6) {
      //   display: block;
      // }

      &:nth-child(n + 16) {
        display: none;
      }
    }
  }

  @include responsive.mq_down(sp) {
    &.sideEvent & {
      &_slotwrap:nth-child(n + 6) {
        display: none;
      }
    }

    &.sidePresent & {
      &_slotwrap:nth-child(n + 3) {
        display: none;
      }
    }

    &.sideGakugeiin & {
      &_slotwrap:nth-child(n + 4) {
        display: none;
      }
    }

    &.sideNews & {
      &_slotwrap:nth-child(n + 4) {
        display: none;
      }
    }

    &.sideSpecial & {
      &_slotwrap:nth-child(n + 4) {
        display: none;
      }
    }
  }
}
</style>
